import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { GlobalService } from '../../global/services/global.service';
import { WorkspaceService } from '../../workspace/workspace.service';
import { AppService } from '../../app.service';
import {
  buildHeaderDataShell,
  normalizeFilterParams,
  rowPayloadFromActiveScreen,
  hydratedGlobalParams,
} from '../../shared/workspace-element-context';

/**
 * Angular CE container for new proforma dashboard.
 */
@Component({
    selector: 'gtw-new-proforma-dashboard',
    templateUrl: './new-proforma-dashboard.component.html',
    styleUrls: ['./new-proforma-dashboard.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class NewProformaDashboardComponent implements OnInit, OnDestroy {
  private readonly subs = new Subscription();
  @Output('request-grid-update') requestGridUpdate = new EventEmitter<string>();

  rowData: any = {};
  filterParams: any = {};
  globalService: any = {};
  GENERAL_CONFIG: any = {};
  private isInitialized = false;
  private isLoading = false;
  selectedFilterType: 'PDF' | 'Efile' = 'PDF';
  showFormLoader = true;

  constructor(
    private cdr: ChangeDetectorRef,
    private gtwGlobal: GlobalService,
    private gtwWorkspace: WorkspaceService,
    private gtwApp: AppService
  ) {}

  ngOnInit(): void {
    this.applyWorkspaceContext();
    this.subs.add(
      this.gtwWorkspace.setTabActive.subscribe(() => {
        this.isInitialized = false;
        this.isLoading = false;
        this.applyWorkspaceContext();
        this.tryInit();
        this.cdr.markForCheck();
      })
    );
    this.subs.add(
      this.gtwGlobal.globalParamsChanged$.subscribe(() => {
        this.isInitialized = false;
        this.isLoading = false;
        this.applyWorkspaceContext();
        this.tryInit();
        this.cdr.markForCheck();
      })
    );
    this.tryInit();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private applyWorkspaceContext(): void {
    const activeScreen = this.gtwWorkspace.workspaceFactory?.activeScreen || {};
    const header = buildHeaderDataShell(this.gtwGlobal, this.gtwApp);
    header.globalParams = hydratedGlobalParams(this.gtwGlobal, this.gtwWorkspace) || header.globalParams || {};
    this.GENERAL_CONFIG = header.generalConfigData || {};
    this.globalService = header.globalParams || {};
    this.filterParams = normalizeFilterParams(activeScreen);
    const rawRow = rowPayloadFromActiveScreen(activeScreen);
    this.rowData = Array.isArray(rawRow) ? (rawRow[0] && typeof rawRow[0] === 'object' ? rawRow[0] : {}) : (rawRow || {});
    this.cdr.markForCheck();
  }

  private tryInit(): void {
    if (this.isInitialized || this.isLoading) return;
    if (!this.GENERAL_CONFIG?.base_url && !this.GENERAL_CONFIG?.api_url) return;
    if (!this.filterParams || Object.keys(this.filterParams).length === 0) return;
    this.isLoading = true;
    this.isInitialized = true;
    this.showFormLoader = false;
    this.isLoading = false;
    this.cdr.markForCheck();
  }

  switchFilters(type: 'PDF' | 'Efile'): void {
    this.selectedFilterType = type;
    this.cdr.markForCheck();
  }

  refresh(): void {
    this.requestGridUpdate.emit('refresh');
  }

  cancel(): void {
    this.requestGridUpdate.emit('cancel');
  }

  get rowDataKeys(): string[] {
    return this.rowData && typeof this.rowData === 'object' ? Object.keys(this.rowData) : [];
  }
}
